import { FC, PropsWithChildren, ReactNode } from "react";
import { IconType } from "react-icons";
import { Icons } from ".";

type SectionIntroProps = {
    Icon?: IconType;
    /** Optional bolded lead-in, for when the first sentence needs to be scannable on its own. */
    title?: ReactNode;
    className?: string;
};

/**
 * Short explanatory panel above a table or form, saying what this screen controls and who it affects.
 *
 * Exists to answer the questions clients currently ask support: which of two similar-looking screens
 * they want, what a setting applies to, and why something behaved the way it did. Deliberately inline
 * and always visible rather than a tooltip or a help link — the person who needs it is the person who
 * has never seen the screen before and won't go looking.
 */
export const SectionIntro: FC<PropsWithChildren<SectionIntroProps>> = ({ Icon = Icons.Info, title, className, children }) => (
    <div className={`flex items-start gap-3 p-3 mb-3 border border-separators-page bg-background-page-highlight-gray text-sm ${className ?? ""}`}>
        <Icon className="shrink-0 mt-1 text-brand-primary" size={18} />
        <div className="space-y-1">
            {title && <div className="font-semibold">{title}</div>}
            {children}
        </div>
    </div>
);
